module.exports = __webpack_public_path__ + "img/Amex.44687131.png";